import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {gql} from '@apollo/client';

import SoldRibbon from '../soldRibbon/SoldRibbon';
import {productUrl} from '../../util/url';

import './ProductPreview.css';

// GraphQL queries
export const PRODUCT_FRAGMENT = gql`
    fragment ProductFragment on ProductNotMine {
        id
        title
        brand
        status
        external_url
        resizedSmallImages
        view_count
    }
`;

export default function ProductPreview({
    product,
    loading = 'lazy',
    fetchPriority,
    width = '600',
    height = '800'
}) {
    // build the UI elements
    return (
        <Link className="ProductPreview"
              to={productUrl(product)}>
            <img className="ProductPreview-image"
                 loading={loading}
                 fetchPriority={fetchPriority}
                 width={width}
                 height={height}
                 alt={product.title}
                 src={product.resizedSmallImages[0]} />
            <div className="ProductPreview-sold">
                <SoldRibbon product={product} />
            </div>
        </Link>
    );
}
ProductPreview.propTypes = {
    product: PropTypes.shape({
        id:  PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        status: PropTypes.oneOf(['selling', 'sold']).isRequired,
        resizedSmallImages: PropTypes.arrayOf(PropTypes.string).isRequired
    }).isRequired,
    loading: PropTypes.oneOf(['eager', 'lazy']),
    fetchPriority: PropTypes.oneOf(['high', 'low', 'auto']),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
